import { useEffect, useState } from "react";
import { fetchPlgTools } from "plg/api/plgAuth";

export interface CatalogueTool {
  name: string;
  logoUrl?: string;
}

let load: Promise<CatalogueTool[] | null> | null = null;

const loadOnce = () =>
  (load ??= fetchPlgTools()
    .then((tools) => {
      const seen = new Set<string>();
      return tools
        .filter((t) => !!t.name && !seen.has(t.name) && !!seen.add(t.name))
        .map((t) => (t.logoUrl ? { name: t.name, logoUrl: t.logoUrl } : { name: t.name }))
        .sort((a, b) => a.name.localeCompare(b.name));
    })
    .catch(() => {
      load = null; // a later screen tries again
      return null;
    }));

/** The marketplace tool catalogue (names and logos) for sign-up search: null while loading or if unavailable. */
export default function usePlgToolCatalogue(): CatalogueTool[] | null {
  const [names, setNames] = useState<CatalogueTool[] | null>(null);
  useEffect(() => {
    let live = true;
    loadOnce().then((n) => {
      if (live) setNames(n);
    });
    return () => {
      live = false;
    };
  }, []);
  return names;
}

export function resetPlgToolCatalogue(): void {
  load = null;
}
